import React from 'react'

import ConnectedShiftExchangeDetail from '../../connectors/ConnectedShiftExchangeDetail/ConnectedShiftExchangeDetail'


export default function ShiftExchangeDetail() {
    return <ConnectedShiftExchangeDetail />
}
